import { useContext } from "react";
import { trpc } from "../../../trpc";
import MerchantContext from "../../../contexts/MerchantContext";
import { Card, CardContent } from "@/components/ui/card";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Spinner } from "@/components/ui/spinner";
import { cn } from "@/lib/utils";

type Step1SelectPipelineProps = {
  selectedPipelineId: string;
  onSelect: (pipelineId: string) => void;
};

const Step1SelectPipeline = ({ selectedPipelineId, onSelect }: Step1SelectPipelineProps) => {
  const { merchantId } = useContext(MerchantContext);

  const { data: pipelines, isLoading } = trpc.pipeline.list.useQuery(
    { merchantId: merchantId || "" },
    { enabled: !!merchantId }
  );

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="flex flex-col items-center gap-4">
          <Spinner size="xl" />
          <p className="text-gray-600">Cargando embudos...</p>
        </div>
      </div>
    );
  }

  if (!pipelines || pipelines.length === 0) {
    return (
      <Card>
        <CardContent className="p-6">
          <p className="py-8 text-center text-gray-500">
            No hay embudos disponibles
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      <div>
        <p className="mb-2 text-lg font-bold">Selecciona un Embudo</p>
        <p className="mb-4 text-sm text-gray-600">
          Elige el embudo del cual quieres enviar mensajes masivos a los leads.
        </p>
      </div>

      <RadioGroup value={selectedPipelineId} onValueChange={onSelect}>
        <div className="flex flex-col gap-3">
          {pipelines.map((pipeline) => (
            <Card
              key={pipeline.id}
              className={cn(
                "cursor-pointer border-2 transition-all hover:border-purple-300 hover:bg-purple-50/50",
                selectedPipelineId === pipeline.id
                  ? "border-purple-500 bg-purple-50"
                  : "border-gray-200"
              )}
              onClick={() => onSelect(pipeline.id)}
            >
              <CardContent className="p-4">
                <div className="flex items-center gap-3">
                  <RadioGroupItem value={pipeline.id} />
                  <div className="flex-1">
                    <p className="font-medium">{pipeline.name}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </RadioGroup>
    </div>
  );
};

export default Step1SelectPipeline;
